import { render, staticRenderFns } from "./wode.vue?vue&type=template&id=4cd71fb6&scoped=true"
import script from "./wode.vue?vue&type=script&lang=js"
export * from "./wode.vue?vue&type=script&lang=js"
import style0 from "./wode.vue?vue&type=style&index=0&id=4cd71fb6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd71fb6",
  null
  
)

export default component.exports